import React, { useState } from 'react';
import { Menu, UserCircle2 } from 'lucide-react';
import { AdminSidebar, AdminPage } from './AdminSidebar';
import { Dashboard } from './pages/Dashboard';
import { PlaylistBuilder } from './pages/PlaylistBuilder';
import { LicenceManager } from './pages/LicenceManager';
import { AnalyticsDashboard } from './pages/AnalyticsDashboard';
import { QrManagement } from './pages/QrManagement';
import { ContentSync } from './pages/ContentSync';
export function WebPreview() {
  const [page, setPage] = useState<AdminPage>('dashboard');
  return <div className="w-full max-w-[1400px]" data-id="element-595" data-mp="25qbstve7xttb">
      <div className="flex h-[80vh] min-h-[640px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg" data-id="element-596" data-mp="2aon48ak5wcdn">
        <AdminSidebar page={page} onNavigate={setPage} data-id="element-597" data-mp="2ertb9kf3m7l6" />

        <div className="flex min-w-0 flex-1 flex-col bg-slate-100" data-id="element-598" data-mp="3m4bpmxhrp3cc">
          {/* Top bar */}
          <header className="flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3" data-id="element-599" data-mp="3q5wze9z091ib">
            <button aria-label="Toggle menu" className="text-slate-500 lg:hidden" data-id="element-600" data-mp="383m9x9caii0m">
              <Menu className="h-5 w-5" data-id="element-601" data-mp="334rumhdj7bl9" />
            </button>
            <span className="hidden font-heading text-sm font-semibold text-slate-700 lg:block" data-id="element-602" data-mp="335azawe683hc">
              Family App Admin Panel
            </span>
            <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-603" data-mp="2u4d3v2hst4ad">
              <UserCircle2 className="h-5 w-5" data-id="element-604" data-mp="2u6frxgze4ncg" />
              admin
            </div>
          </header>

          <div className="min-h-0 flex-1 overflow-y-auto p-5" data-id="element-605" data-mp="2kea3uic9eq2j">
            {page === 'dashboard' && <Dashboard onNavigate={setPage} data-id="element-606" data-mp="2kcgw0zpwtzsy" />}
            {page === 'playlists' && <PlaylistBuilder data-id="element-607" data-mp="2ffqee7ygiw5f" />}
            {page === 'licences' && <LicenceManager data-id="element-608" data-mp="2agm8bq6txejb" />}
            {page === 'analytics' && <AnalyticsDashboard data-id="element-609" data-mp="2ae13csb8iihc" />}
            {page === 'qr' && <QrManagement data-id="element-610" data-mp="26esbxu3o2woy" />}
            {page === 'sync' && <ContentSync data-id="element-611" data-mp="26glhf62jnavd" />}
          </div>
        </div>
      </div>
    </div>;
}